export const isStringTypesafe = (value: unknown): value is string =>
  typeof value === 'string'
